import { cn } from "@/lib/class-control";
import { Check } from "lucide-react";

type SectionType = "Configuração de Conta" | "Alterar Senha" | "Permissões" | "Termos de Uso";

interface ConfiguracoesHeaderProps {
  activeSection: SectionType;
  onSectionChange: (section: SectionType) => void;
}

export function ConfiguracoesHeader({
  activeSection,
  onSectionChange,
}: ConfiguracoesHeaderProps) {
  const sections: SectionType[] = [
    "Configuração de Conta",
    "Alterar Senha",
    "Permissões",
    "Termos de Uso",
  ];

  return (
    <div className="flex flex-col gap-4 w-full">
      {/* Title and Navigation Buttons */}
      <div className="flex items-end justify-between w-full">
        {/* Left side: Divider + Title + Tabs */}
        <div className="flex items-end">
          {/* Purple divider */}
          <div className="bg-[#7846ff] h-full rounded-lg w-[2px] self-stretch" />

          {/* Title and navigation buttons */}
          <div className="flex flex-col gap-3 w-[1175px]">
            {/* Navigation tabs */}
            <div className="flex items-center gap-2">
              {sections.map((section) => {
                const isActive = section === activeSection;
                const width = section === "Configuração de Conta" ? "w-[205px]" : "w-[174px]";

                return (
                  <button
                    key={section}
                    onClick={() => onSectionChange(section)}
                    className={cn(
                      "h-btn-default flex items-center justify-center px-btn-x py-btn-y rounded-lg transition-colors",
                      "font-['Plus_Jakarta_Sans'] font-bold text-sm leading-normal whitespace-nowrap",
                      width,
                      isActive
                        ? "bg-[#7846ff] text-[#f5f2ff]"
                        : "border-0.5 border-[#7846ff] text-[#7846ff] hover:bg-[#7846ff]/10"
                    )}
                  >
                    {section}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
